export function unlikeResourceTypePatcher(data) {
    return {
        __typename: 'UnlikeResource',
        ...data,
        unlikeResource: {
            __typename: 'UnlikeResource',
            ...data.unlikeResource,
        },
    };
}
